import { createRootRoute, createRoute, createRouter, redirect } from '@tanstack/react-router';

import { CAMINHO_ANTIGO_DO_LOGIN, CAMINHO_DO_LOGIN, CAMINHO_DO_PRIMEIRO_ACESSO, Casca } from '@/componentes/Casca';
import { PaginaLogin } from '@/modulos/acesso/PaginaLogin';
import { PaginaPrimeiroAcesso } from '@/modulos/acesso/PaginaPrimeiroAcesso';
import { PaginaPlataforma } from '@/modulos/plataforma/PaginaPlataforma';
import { PaginaPrimeiroAcessoPlataforma } from '@/modulos/plataforma/PaginaPrimeiroAcessoPlataforma';
import { validarBuscaDaPlataforma } from '@/modulos/plataforma/gestao';
import { PaginaPerfil } from '@/modulos/acesso/PaginaPerfil';
import { PaginaCausas } from '@/modulos/operacao/PaginaCausas';
import { PaginaFolhaDeTurnoImpressa } from '@/modulos/operacao/PaginaFolhaDeTurnoImpressa';
import { PaginaFolhasDeTurno } from '@/modulos/operacao/PaginaFolhasDeTurno';
import { PaginaConciliacaoDeHoras } from '@/modulos/operacao/PaginaConciliacaoDeHoras';
import { PaginaImportacoes } from '@/modulos/operacao/PaginaImportacoes';
import { validarBuscaDaConciliacao } from '@/modulos/operacao/conciliacao';
import { validarBuscaDaManutencao } from '@/modulos/manutencao/busca';
import { PaginaManutencao } from '@/modulos/manutencao/PaginaManutencao';
import { PaginaCustos } from '@/modulos/custos/PaginaCustos';
import { validarBuscaDeCompras } from '@/modulos/compras/compras';
import { PaginaCompras } from '@/modulos/compras/PaginaCompras';
import { PaginaChecklists } from '@/modulos/inspecao/PaginaChecklists';
import { PaginaInspecao } from '@/modulos/inspecao/PaginaInspecao';
import { PaginaPessoas } from '@/modulos/pessoas/PaginaPessoas';
import { PaginaReceita } from '@/modulos/receita/PaginaReceita';
import { validarBuscaDoEstoque } from '@/modulos/estoque/busca';
import { PaginaEstoque } from '@/modulos/estoque/PaginaEstoque';
import { PaginaGestor } from '@/modulos/painel/PaginaGestor';
import { validarBuscaDoGestor } from '@/modulos/painel/gestor';
import { PaginaQualidadeDaIa } from '@/modulos/painel/PaginaQualidadeDaIa';
import { validarBuscaDaQualidade } from '@/modulos/painel/qualidadeDaIa';
import { PaginaPiloto } from '@/modulos/piloto/PaginaPiloto';
import {
  PaginaConciliacaoDaTelemetria,
  PaginaFilaDaTelemetria,
  PaginaIntegracoesDaTelemetria,
  PaginaSinalDaTelemetria,
} from '@/modulos/telemetria/PaginaTelemetria';
import { validarBuscaDaConciliacaoDaTelemetria, validarBuscaDaFila } from '@/modulos/telemetria/telemetria';
import {
  PaginaHistoricoDeFalhas,
  PaginaPrevisoesEmPiloto,
  PaginaPropostasTecnicas,
  PaginaRecorrencias,
} from '@/modulos/preditiva/PaginaPreditiva';
import {
  validarBuscaDaRecorrencia,
  validarBuscaDasFalhas,
  validarBuscaDasPrevisoes,
  validarBuscaDasPropostas,
} from '@/modulos/preditiva/preditiva';
import { validarBuscaDoPiloto } from '@/modulos/piloto/piloto';
import { PaginaFinanceiro } from '@/modulos/financeiro/PaginaFinanceiro';
import { validarBuscaDoFinanceiro } from '@/modulos/financeiro/financeiro';
import { PaginaOrcamento } from '@/modulos/orcamento/PaginaOrcamento';
import { PaginaEstudo } from '@/modulos/renovacao/PaginaEstudo';
import { PaginaInvestimentos } from '@/modulos/renovacao/PaginaInvestimentos';
import { PaginaRenovacao } from '@/modulos/renovacao/PaginaRenovacao';
import { validarBuscaDaRenovacao, validarBuscaDosInvestimentos } from '@/modulos/renovacao/renovacao';
import { validarBuscaDoOrcamento } from '@/modulos/orcamento/orcamento';
import {
  PaginaCorrespondencias,
  PaginaDivergenciasDaTroca,
  PaginaLotesDeIntegracao,
  PaginaMatrizDeIntegracao,
} from '@/modulos/integracoes/PaginaIntegracoes';
import { PaginaLoteDeIntegracao } from '@/modulos/integracoes/PaginaLoteDeIntegracao';
import { PaginaTitulosENotas } from '@/modulos/integracoes/PaginaTitulosENotas';
import { validarBuscaDasDivergencias, validarBuscaDoLote, validarBuscaDosLotes, validarBuscaDosTitulos } from '@/modulos/integracoes/integracoes';
import { PaginaPainel } from '@/modulos/painel/PaginaPainel';
import { validarBuscaDasOrdens } from '@/modulos/oficina/busca';
import { PaginaOrdensDeServico } from '@/modulos/oficina/PaginaOrdensDeServico';
import { PaginaOperacao } from '@/modulos/operacao/PaginaOperacao';
import { PaginaPrevia } from '@/modulos/previa/PaginaPrevia';
import { PaginaCadastros } from '@/modulos/cadastros/PaginaCadastros';
import { PaginaGovernanca } from '@/modulos/cadastros/PaginaGovernanca';
import { PaginaTrilha } from '@/modulos/cadastros/PaginaTrilha';
import {
  validarBuscaDaTrilha,
  validarBuscaDeCadastros,
  validarBuscaDeGovernanca,
} from '@/modulos/cadastros/busca';
import { PaginaCadastrosDoCombustivel } from '@/modulos/combustivel/PaginaCadastrosDoCombustivel';
import { PaginaBiblioteca } from '@/modulos/tecnico/PaginaBiblioteca';
import { PaginaCombustivel } from '@/modulos/combustivel/PaginaCombustivel';
import { PaginaConciliacao } from '@/modulos/combustivel/PaginaConciliacao';
import { PaginaConsumo } from '@/modulos/combustivel/PaginaConsumo';
import { PaginaFolhaImpressa } from '@/modulos/combustivel/PaginaFolhaImpressa';
import { PaginaFolhas } from '@/modulos/combustivel/PaginaFolhas';
import { PaginaLancamento } from '@/modulos/combustivel/PaginaLancamento';
import { PaginaLancamentoCompleto } from '@/modulos/combustivel/PaginaLancamentoCompleto';
import { PaginaOrdens } from '@/modulos/combustivel/PaginaOrdens';
import { PaginaTanques } from '@/modulos/combustivel/PaginaTanques';
import {
  validarBuscaDaLista,
  validarBusca as validarBuscaDeLancamentos,
} from '@/modulos/combustivel/busca';
import { PaginaCadastro } from '@/modulos/equipamentos/PaginaCadastro';
import { PaginaImportacao } from '@/modulos/equipamentos/PaginaImportacao';
import { PaginaCatalogo } from '@/modulos/equipamentos/PaginaCatalogo';
import { PaginaIdentificacao } from '@/modulos/equipamentos/PaginaIdentificacao';
import { PaginaEquipamentos } from '@/modulos/equipamentos/PaginaEquipamentos';
import { validarBusca } from '@/modulos/equipamentos/busca';

import { EnderecoInexistente, TelaQueFalhou } from './TelasDeFalha';
import { validarBuscaDePeriodo } from '@/lib/busca-de-periodo';
import { LEITURA_DA_TELA } from '@/modulos/acesso/telas';

import { comLeitura, soNaEmpresaInteira } from './leitura';

/**
 * Arvore de rotas escrita a mao, nao gerada.
 *
 * O roteamento por arquivo do TanStack exige um passo de geracao de codigo.
 * Com quatro rotas isso troca clareza por magia: `npx tsc --noEmit` passaria a
 * depender de um arquivo que alguem precisa lembrar de regerar. Quando o numero
 * de rotas justificar, a troca e mecanica.
 */

const rotaRaiz = createRootRoute({
  /* `Casca` e nao `Estrutura`: o login roda fora da barra superior e da
     navegacao lateral, e a decisao de dar ou nao a casca a tela mora la, com
     o motivo por extenso. */
  component: Casca,
});

/**
 * O login (p.24: e a tela que, junto com o topo do sistema, leva as duas
 * marcas).
 *
 * NAO HA GUARDA DE ROTA, e isso e deliberado. Nenhuma rota exige persona
 * escolhida: `/equipamentos` e `/combustivel` continuam abrindo direto, como
 * sempre abriram. Nao ha autenticacao — nao ha senha, nao ha sessao, e a
 * selecao de persona nao protege nada (historia F-04). Um redirecionamento
 * para ca daria a impressao contraria, que e exatamente o que esta tela passa
 * o tempo inteiro desmentindo.
 */
const rotaLogin = createRoute({
  getParentRoute: () => rotaRaiz,
  path: CAMINHO_DO_LOGIN,
  component: PaginaLogin,
});

/** `/login`, o nome antigo: redireciona para `/entrar`, levando a busca e o fragmento. */
const rotaLoginAntigo = createRoute({
  getParentRoute: () => rotaRaiz,
  path: CAMINHO_ANTIGO_DO_LOGIN,
  beforeLoad: ({ location }) => {
    throw redirect({ to: CAMINHO_DO_LOGIN, search: location.search, hash: location.hash, replace: true });
  },
});

/** O convite de primeiro acesso (0024): a pessoa escolhe a senha. O codigo vem no fragmento do endereco. */
const rotaPrimeiroAcesso = createRoute({
  getParentRoute: () => rotaRaiz,
  path: CAMINHO_DO_PRIMEIRO_ACESSO,
  component: PaginaPrimeiroAcesso,
});

/** A administração da plataforma (0029, decisão 21; gestão, 0032, decisão 25): acima das empresas, com sessão própria. */
const rotaPlataforma = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/plataforma',
  validateSearch: validarBuscaDaPlataforma,
  component: PaginaPlataforma,
});

const rotaPrimeiroAcessoPlataforma = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/plataforma/primeiro-acesso',
  component: PaginaPrimeiroAcessoPlataforma,
});

const rotaInicio = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/',
  beforeLoad: () => {
    /* A raiz abre o PAINEL desde o passo 9: a primeira pergunta de todo dia e
       "o que pede atencao hoje", e o painel responde com a frota dentro. Antes
       ela abria a frota direto. */
    throw redirect({ to: '/painel' });
  },
});

const rotaEquipamentos = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/equipamentos',
  validateSearch: validarBusca,
  component: PaginaEquipamentos,
});

/**
 * As duas telas de escrita do modulo 02.
 *
 * Elas sao rotas proprias, e nao um modal sobre a lista, por duas razoes do
 * manual: formulario longo mora em coluna unica de 560 px (p.16), e a acao
 * primaria de uma tela e uma so (p.15) — com o formulario dentro da lista,
 * "Cadastrar equipamento" e o botao do formulario seriam dois laranjas
 * competindo. O caminho e escrito inteiro, como o de lancamento de
 * combustivel, porque nao ha casca comum entre a lista e o cadastro.
 */
const rotaNovoEquipamento = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/equipamentos/novo',
  component: PaginaCadastro,
});

/** A importação da frota pela planilha (0060): página própria, pela mesma razão do cadastro. */
const rotaImportarEquipamentos = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/equipamentos/importar',
  component: PaginaImportacao,
});

const rotaCatalogo = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/equipamentos/catalogo',
  /* Guardada como as outras (robôs, 20/10/2026): sem `catalogo.ler`, o
     operador abria o catálogo pelo endereço e recebia o erro de carregar. */
  component: comLeitura(PaginaCatalogo, { licenca: LEITURA_DA_TELA['/equipamentos/catalogo'], modulo: 'o catálogo de modelos', sobretitulo: 'Frota', titulo: 'Catálogo' }),
});

/**
 * A identificação das máquinas (decisão 64, 31/10/2026): o PDF dos adesivos,
 * com o código e os QR, para a gráfica. Dentro da casca, como as outras telas
 * da frota: ela escolhe e gera o arquivo, e o papel sai da gráfica, não da
 * impressora de quem está na tela.
 */
const rotaIdentificacao = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/equipamentos/identificacao',
  component: comLeitura(PaginaIdentificacao, { licenca: LEITURA_DA_TELA['/equipamentos/identificacao'], modulo: 'a frota', sobretitulo: 'Frota', titulo: 'Identificação' }),
});

/**
 * As tres telas do modulo 01 — cadastros e governanca.
 *
 * Os caminhos sao escritos inteiros, como os do combustivel, e pelo mesmo
 * motivo: as tres nao compartilham casca nenhuma. Estrutura e uma lista com
 * formulario, governanca tem tres vistas proprias e a auditoria e so leitura.
 */
/**
 * MODULO 22 — a previa do sistema, para quem apresenta.
 *
 * SEM entrada no menu lateral, e isso e decisao, nao esquecimento: o
 * vocabulario de icones do manual (p.14) tem doze entradas e nenhuma e
 * "previa" ou "galeria". Criar um icone e de quem assina o manual, e o
 * CLAUDE.md e explicito que conceito novo sem entrada no manual e achado.
 * Ate la ela e alcancada por "Meu perfil".
 */
const rotaPrevia = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/previa',
  component: PaginaPrevia,
});

const rotaCadastros = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/cadastros',
  validateSearch: validarBuscaDeCadastros,
  component: comLeitura(PaginaCadastros, { licenca: LEITURA_DA_TELA['/cadastros'], modulo: 'os cadastros da estrutura', sobretitulo: 'Cadastros e governança', titulo: 'Estrutura e centros de custo' }),
});

const rotaGovernanca = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/cadastros/governanca',
  validateSearch: validarBuscaDeGovernanca,
  component: comLeitura(PaginaGovernanca, { licenca: LEITURA_DA_TELA['/cadastros/governanca'], modulo: 'a governança', sobretitulo: 'Cadastros e governança', titulo: 'Perfis e responsáveis' }),
});

const rotaTrilha = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/cadastros/trilha',
  validateSearch: validarBuscaDaTrilha,
  component: comLeitura(PaginaTrilha, { licenca: LEITURA_DA_TELA['/cadastros/trilha'], modulo: 'a auditoria', sobretitulo: 'Cadastros e governança', titulo: 'Auditoria e histórico' }),
});

const rotaCombustivel = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/combustivel',
  validateSearch: validarBuscaDaLista,
  component: comLeitura(PaginaCombustivel, { licenca: LEITURA_DA_TELA['/combustivel'], modulo: 'o combustível', sobretitulo: 'Frota', titulo: 'Combustível' }),
});

/**
 * O caminho e escrito inteiro (`/combustivel/lancamento`), e nao aninhado sob a
 * rota de combustivel. Aninhar exigiria um `<Outlet />` no meio da pagina de
 * lancamentos, e as duas telas do modulo nao compartilham casca nenhuma: uma e
 * a lista por equipamento e obra, a outra alimenta o sistema. Quando houver
 * casca comum — um cabecalho de modulo, por exemplo —, o aninhamento passa a
 * pagar o proprio preco.
 */
const rotaLancamento = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/combustivel/lancamento',
  validateSearch: validarBuscaDeLancamentos,
  component: comLeitura(PaginaLancamento, { licenca: LEITURA_DA_TELA['/combustivel/lancamento'], modulo: 'o combustível', sobretitulo: 'Frota', titulo: 'Combustível' }),
});

/**
 * O FORMULARIO INTEIRO, numa tela propria (entrega do dono, 25/10/2026).
 *
 * A aba "Lancamentos" ficou com a lista e a linha rapida de quatro perguntas,
 * que e o lancamento do dia a dia. Esta tela guarda o que nao cabe nelas: o
 * posto com cupom e preco, a data retroativa, a ordem de abastecimento e as
 * pessoas. Mesma licenca de leitura: quem le o combustivel abre as duas.
 */
const rotaLancamentoCompleto = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/combustivel/lancamento/completo',
  /* A linha rapida manda a maquina ja escolhida: quem clicou em "Mais
     campos" nao a escolhe de novo. Codigo, e nao id — e o que a tela usa. */
  validateSearch: (busca: Record<string, unknown>): { readonly equipamento?: string } =>
    typeof busca['equipamento'] === 'string' && busca['equipamento'] !== '' ? { equipamento: busca['equipamento'] } : {},
  component: comLeitura(PaginaLancamentoCompleto, { licenca: LEITURA_DA_TELA['/combustivel/lancamento/completo'], modulo: 'o combustível', sobretitulo: 'Frota', titulo: 'Combustível' }),
});

/**
 * As tres telas que faltavam do modulo 08, uma por ferramenta do mapa
 * funcional: tanque e saldo (1), ordem de abastecimento (2) e consumo com
 * lubrificantes (4). A conciliacao de cobranca e a segunda metade da
 * ferramenta 3 — a primeira metade, o abastecimento externo, entra pelo mesmo
 * formulario de lancamento.
 *
 * Nenhuma delas tem `validateSearch`: nao ha filtro nessas telas ainda, e
 * declarar busca vazia so para uniformizar criaria URL com parametro que nao
 * diz nada a quem le.
 */
const rotaTanques = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/combustivel/tanques',
  component: comLeitura(PaginaTanques, { licenca: LEITURA_DA_TELA['/combustivel/tanques'], modulo: 'o combustível', sobretitulo: 'Frota', titulo: 'Combustível' }),
});

const rotaOrdens = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/combustivel/ordens',
  component: comLeitura(PaginaOrdens, { licenca: LEITURA_DA_TELA['/combustivel/ordens'], modulo: 'o combustível', sobretitulo: 'Frota', titulo: 'Combustível' }),
});

const rotaConsumo = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/combustivel/consumo',
  component: comLeitura(PaginaConsumo, { licenca: LEITURA_DA_TELA['/combustivel/consumo'], modulo: 'o combustível', sobretitulo: 'Frota', titulo: 'Combustível' }),
});

const rotaConciliacao = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/combustivel/cobrancas',
  component: comLeitura(PaginaConciliacao, { licenca: LEITURA_DA_TELA['/combustivel/cobrancas'], modulo: 'o combustível', sobretitulo: 'Frota', titulo: 'Combustível' }),
});

/** A folha de campo lida pela IA (0035; decisões 9, 10 e 12). */
const rotaFolhas = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/combustivel/folhas',
  component: comLeitura(PaginaFolhas, { licenca: LEITURA_DA_TELA['/combustivel/folhas'], modulo: 'o combustível', sobretitulo: 'Frota', titulo: 'Combustível' }),
});

/**
 * Modulo 03 — a folha de turno (0041): a lista, a leitura e a conferencia sob
 * a Operacao; a folha impressa fora da casca, como a de combustivel.
 */
const rotaFolhasDeTurno = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/operacao/folhas',
  component: comLeitura(PaginaFolhasDeTurno, { licenca: LEITURA_DA_TELA['/operacao/folhas'], modulo: 'a operação', sobretitulo: 'Operação', titulo: 'Folhas de turno' }),
});

const rotaFolhaDeTurnoImpressa = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/impressao/folha-de-turno/$id',
  component: PaginaFolhaDeTurnoImpressa,
});

/** A folha para o papel: fora da casca, sem menu. */
const rotaFolhaImpressa = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/impressao/folha/$id',
  component: PaginaFolhaImpressa,
});

/**
 * Os adesivos de leitura de 26/10/2026, substituidos pela Identificacao
 * (decisao 64): o endereco antigo leva a ela, para o link guardado de quem
 * imprimia por la nao cair numa pagina em branco.
 */
const rotaAdesivos = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/impressao/adesivos',
  beforeLoad: () => {
    throw redirect({ to: '/equipamentos/identificacao', replace: true });
  },
});

/**
 * Os cadastros do modulo. O caminho e `/combustivel/cadastros`, e o seletor de
 * qual lista (tanque, posto, produto) NAO vai para a URL — diferente do modulo
 * 01, que leva `?tipo=` porque aquela tela tem filtro e pagina, e um link para
 * uma lista filtrada e util. Aqui nao ha filtro: o link seria so "abri outra
 * aba", que nao vale o parametro na URL.
 */
const rotaCadastrosDoCombustivel = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/combustivel/cadastros',
  component: comLeitura(PaginaCadastrosDoCombustivel, { licenca: LEITURA_DA_TELA['/combustivel/cadastros'], modulo: 'o combustível', sobretitulo: 'Frota', titulo: 'Combustível' }),
});

/**
 * Modulo 12 — a biblioteca tecnica. Passo 2 da sequencia do primeiro ciclo.
 *
 * `/tecnico` e nao `/biblioteca`: o item da navegacao se chama biblioteca, mas
 * o schema, as rotas da API e o modulo se chamam `tecnico`. Um nome so do
 * comeco ao fim evita a pergunta "isto aqui e a mesma coisa daquilo?".
 */
const rotaBiblioteca = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/tecnico',
  /* `?documento=` abre o painel daquele documento: e por onde a busca da barra
     superior entrega o manual achado. */
  validateSearch: (busca: Record<string, unknown>): { readonly documento?: string } =>
    typeof busca['documento'] === 'string' && busca['documento'] ? { documento: busca['documento'] } : {},
  component: comLeitura(PaginaBiblioteca, { licenca: LEITURA_DA_TELA['/tecnico'], modulo: 'a biblioteca técnica', sobretitulo: 'Biblioteca técnica', titulo: 'Manuais e documentos' }),
});

/**
 * Meu perfil — a descricao completa da persona de quem esta logado.
 *
 * `/perfil` e nao `/cadastros/perfis`: nao e cadastro. Ela nao grava nada e
 * nao e sobre OUTRAS pessoas — e a ficha de quem abriu, alcancada pelo nome na
 * barra superior. O conteudo morava na tela de LOGIN, visivel sem sessao; aqui
 * ele fica atras da sessao, que e onde ele pertence.
 */
const rotaPerfil = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/perfil',
  component: PaginaPerfil,
});

/**
 * Modulo 03 — operacao, horas e paradas. Passo 4 da sequencia do ciclo 1.
 *
 * `/operacao` e nao `/horimetro`: o item da navegacao nasceu chamado
 * "Horimetro" quando so a leitura de medidor existia, e o modulo e maior que
 * isso — apontamento de turno, horas por natureza e causa de parada. O `id` do
 * item continua `horimetro` pelo mesmo motivo que o de Cadastros continua
 * `obras`: e ele que a proposta de permissao usa, e trocar o id reescreveria a
 * proposta para caber num nome interno.
 */
const rotaOperacao = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/operacao',
  component: comLeitura(PaginaOperacao, { licenca: LEITURA_DA_TELA['/operacao'], modulo: 'a operação', sobretitulo: 'Operação', titulo: 'Turnos, horas e paradas' }),
});

/**
 * O catalogo de causas de parada.
 *
 * `/operacao/cadastros` pelo mesmo desenho de `/combustivel/cadastros`: o que
 * precisa EXISTIR antes do primeiro registro mora sob o modulo que o consome,
 * e nao numa area de cadastros geral — a causa de parada e do 03, como o tanque
 * e do 08.
 */
const rotaCausas = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/operacao/cadastros',
  component: comLeitura(PaginaCausas, { licenca: LEITURA_DA_TELA['/operacao/cadastros'], modulo: 'a operação', sobretitulo: 'Operação', titulo: 'Causas e turno' }),
});

/**
 * Modulo 21 — a visao do gestor, sob o Painel: o executivo do periodo e a
 * fila de prioridades por maquina. A rota do backend exige `custo.ler`; o menu
 * a mostra a quem abre o Painel, mesmo sem `custo.ler` — nesse caso a tela
 * recebe 403 e diz o que fazer.
 */
/**
 * Etapa C — a qualidade da IA, sob o Painel: o registro de toda saida da IA, a
 * utilidade, o acerto da leitura e o custo (guia 6.3). A rota exige
 * `ia.auditar`; sem ela a tela diz qual perfil pedir.
 */
const rotaQualidadeDaIa = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/painel/ia',
  validateSearch: validarBuscaDaQualidade,
  component: PaginaQualidadeDaIa,
});

/**
 * Modulo 21 — o piloto controlado (guia §17), sob o Painel como a visao do
 * gestor: os sete indicadores do §17.2, a carga inicial (§17.1) e o grupo do
 * piloto. A aba, o periodo e os filtros da carga vao para o endereco (p.16).
 */
const rotaPiloto = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/painel/piloto',
  validateSearch: validarBuscaDoPiloto,
  component: PaginaPiloto,
});

/**
 * Modulo 15 — o financeiro gerencial e a DRE (0102): a DRE por recorte, o
 * plano de contas gerencial e os titulos. A aba, o periodo, a competencia
 * final e o recorte vao para o endereco (p.16).
 */
const rotaFinanceiro = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/financeiro',
  validateSearch: validarBuscaDoFinanceiro,
  component: PaginaFinanceiro,
});

/**
 * Modulo 19 — o orcamento e planejamento (0106), sob Custos: o orcamento por
 * centro, o previsto x realizado, os cenarios e o caixa. A aba, a versao e a
 * competencia vao para o endereco (p.16).
 */
const rotaOrcamento = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/orcamento',
  validateSearch: validarBuscaDoOrcamento,
  component: soNaEmpresaInteira(PaginaOrcamento, { caminho: '/orcamento', sobretitulo: 'Orçamento e planejamento', titulo: 'Orçamento e caixa' }),
});

/**
 * Modulo 20 — a renovacao e estrategia da frota (0107): a lista da frota pela
 * economia de cada maquina, sob Frota; o estudo de reforma ou substituicao em
 * pagina propria (premissas em secoes e as alternativas lado a lado); e o
 * plano de investimentos, sob Custos. O filtro, a ordem e a aba vao para o
 * endereco (p.16).
 */
const rotaRenovacao = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/equipamentos/renovacao',
  validateSearch: validarBuscaDaRenovacao,
  component: soNaEmpresaInteira(PaginaRenovacao, { caminho: '/equipamentos/renovacao', sobretitulo: 'Frota', titulo: 'Renovação da frota' }),
});
const rotaEstudoDeRenovacao = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/equipamentos/renovacao/estudos/$estudoId',
  component: soNaEmpresaInteira(PaginaEstudo, { caminho: '/equipamentos/renovacao', sobretitulo: 'Renovação da frota', titulo: 'Estudo de renovação' }),
});
const rotaInvestimentos = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/investimentos',
  validateSearch: validarBuscaDosInvestimentos,
  component: soNaEmpresaInteira(PaginaInvestimentos, { caminho: '/investimentos', sobretitulo: 'Custos', titulo: 'Plano de investimentos' }),
});

/**
 * Modulo 17 — a telemetria (0103), sob a Operacao: quatro abas com endereco
 * proprio (o sinal, a fila, a conciliacao e as integracoes), como o hub do
 * combustivel. As quatro leem `telemetria.ler`; sem ela, o perfil a pedir.
 */
const TELA_DA_TELEMETRIA = { licenca: LEITURA_DA_TELA['/operacao/telemetria'], modulo: 'a telemetria', sobretitulo: 'Operação', titulo: 'Telemetria' } as const;
const rotaTelemetria = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/operacao/telemetria',
  component: comLeitura(PaginaSinalDaTelemetria, TELA_DA_TELEMETRIA),
});
const rotaFilaDaTelemetria = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/operacao/telemetria/fila',
  validateSearch: validarBuscaDaFila,
  component: comLeitura(PaginaFilaDaTelemetria, TELA_DA_TELEMETRIA),
});
const rotaConciliacaoDaTelemetria = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/operacao/telemetria/conciliacao',
  validateSearch: validarBuscaDaConciliacaoDaTelemetria,
  component: comLeitura(PaginaConciliacaoDaTelemetria, TELA_DA_TELEMETRIA),
});
const rotaIntegracoesDaTelemetria = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/operacao/telemetria/integracoes',
  component: comLeitura(PaginaIntegracoesDaTelemetria, TELA_DA_TELEMETRIA),
});

/**
 * Modulo 18 — a manutencao preditiva (0105), sob a Manutencao: quatro abas com
 * endereco proprio (o historico de falhas, as recorrencias, as previsoes em
 * piloto e as propostas tecnicas). Todas leem `preditiva.ler`; sem ela, o
 * perfil a pedir.
 */
const TELA_DA_PREDITIVA = { licenca: LEITURA_DA_TELA['/manutencao/preditiva'], modulo: 'a preditiva', sobretitulo: 'Manutenção', titulo: 'Falhas e preditiva' } as const;
const rotaHistoricoDeFalhas = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/manutencao/preditiva',
  validateSearch: validarBuscaDasFalhas,
  component: comLeitura(PaginaHistoricoDeFalhas, TELA_DA_PREDITIVA),
});
const rotaRecorrencias = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/manutencao/preditiva/recorrencias',
  validateSearch: validarBuscaDaRecorrencia,
  component: comLeitura(PaginaRecorrencias, TELA_DA_PREDITIVA),
});
const rotaPrevisoesEmPiloto = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/manutencao/preditiva/previsoes',
  validateSearch: validarBuscaDasPrevisoes,
  component: comLeitura(PaginaPrevisoesEmPiloto, TELA_DA_PREDITIVA),
});
const rotaPropostasTecnicas = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/manutencao/preditiva/propostas',
  validateSearch: validarBuscaDasPropostas,
  component: comLeitura(PaginaPropostasTecnicas, TELA_DA_PREDITIVA),
});

/**
 * Modulo 04 — as integracoes com o ERP (0104), sob Cadastros: quatro abas com
 * endereco proprio (a matriz, os lotes, as correspondencias e as divergencias)
 * e o lote em pagina propria, com cada linha. Todas leem `integracao.ler`;
 * sem ela, o perfil a pedir.
 */
const TELA_DAS_INTEGRACOES = { licenca: LEITURA_DA_TELA['/cadastros/integracoes'], modulo: 'as integrações', sobretitulo: 'Cadastros e governança', titulo: 'Integrações' } as const;
const rotaMatrizDeIntegracao = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/cadastros/integracoes',
  component: comLeitura(PaginaMatrizDeIntegracao, TELA_DAS_INTEGRACOES),
});
const rotaLotesDeIntegracao = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/cadastros/integracoes/lotes',
  validateSearch: validarBuscaDosLotes,
  component: comLeitura(PaginaLotesDeIntegracao, TELA_DAS_INTEGRACOES),
});
const rotaLoteDeIntegracao = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/cadastros/integracoes/lotes/$loteId',
  validateSearch: validarBuscaDoLote,
  component: comLeitura(PaginaLoteDeIntegracao, TELA_DAS_INTEGRACOES),
});
/* 0108: a fatia b — os titulos, as baixas, as notas (so como referencia) e as contingencias. */
const rotaTitulosDaIntegracao = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/cadastros/integracoes/titulos',
  /* 0109: o aviso do título vencido abre a vista e o título (`?vista=…&titulo=…`). */
  validateSearch: validarBuscaDosTitulos,
  component: comLeitura(PaginaTitulosENotas, TELA_DAS_INTEGRACOES),
});
const rotaCorrespondencias = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/cadastros/integracoes/correspondencias',
  component: comLeitura(PaginaCorrespondencias, TELA_DAS_INTEGRACOES),
});
const rotaDivergenciasDaTroca = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/cadastros/integracoes/divergencias',
  validateSearch: validarBuscaDasDivergencias,
  component: comLeitura(PaginaDivergenciasDaTroca, TELA_DAS_INTEGRACOES),
});

const rotaGestor = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/painel/gestor',
  /* O PERIODO NA URL (p.16): "o estado dos filtros vai para a URL, para o
     usuario salvar e compartilhar a visao". Num painel de gestao isso tem
     consequencia direta — a conversa e "olha esse mes aqui", e o link tem de
     levar o mes. O validador e o mesmo de Custos, que filtra o mesmo periodo,
     mais o dia (`?dia=ontem`) e o agrupamento da fila (`?fila=obra`), 0091. */
  validateSearch: validarBuscaDoGestor,
  component: comLeitura(PaginaGestor, { licenca: LEITURA_DA_TELA['/painel/gestor'], modulo: 'a visão do gestor', sobretitulo: 'Painel', titulo: 'Visão do gestor' }),
});

/**
 * OPE 03 — a conciliacao de horas e a area de estagio do arquivo do cliente.
 *
 * Duas telas, e nao uma: importar e conferir um lote e trabalho de quem recebe
 * o arquivo; tratar a fila e trabalho de quem responde pela divergencia. Cada
 * uma tem a sua acao primaria (p.15). A fila tem o filtro na URL (p.16).
 */
const rotaConciliacaoDeHoras = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/operacao/conciliacao',
  validateSearch: validarBuscaDaConciliacao,
  component: comLeitura(PaginaConciliacaoDeHoras, { licenca: LEITURA_DA_TELA['/operacao/conciliacao'], modulo: 'a operação', sobretitulo: 'Operação', titulo: 'Conciliação de horas' }),
});

const rotaImportacoes = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/operacao/importacoes',
  component: comLeitura(PaginaImportacoes, { licenca: LEITURA_DA_TELA['/operacao/importacoes'], modulo: 'a operação', sobretitulo: 'Operação', titulo: 'Importações de horas' }),
});

/**
 * Modulo 05 — manutencao planejada. Passo 5 da sequencia do ciclo 1: plano
 * preventivo revisado (MAN 01) e a fila de vencimentos (MAN 02).
 */
const rotaManutencao = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/manutencao',
  validateSearch: validarBuscaDaManutencao,
  component: PaginaManutencao,
});

/**
 * Modulo 06 — oficina e ordens de servico. Passo 6 da sequencia do ciclo 1.
 * `/ordens` e nao `/oficina`: o item do menu ja se chamava "Ordens de servico",
 * e e a palavra que a obra usa.
 */
const rotaOrdensDeServico = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/ordens',
  validateSearch: validarBuscaDasOrdens,
  component: comLeitura(PaginaOrdensDeServico, { licenca: LEITURA_DA_TELA['/ordens'], modulo: 'as ordens de serviço', sobretitulo: 'Oficina', titulo: 'Ordens de serviço' }),
});

/** Modulo 07 — estoque e almoxarifado. Passo 7 da sequencia do ciclo 1. */
const rotaEstoque = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/estoque',
  validateSearch: validarBuscaDoEstoque,
  component: comLeitura(PaginaEstoque, { licenca: LEITURA_DA_TELA['/estoque'], modulo: 'o estoque', sobretitulo: 'Almoxarifado', titulo: 'Estoque' }),
});

/** Passo 9 do ciclo 1 — o painel de excecoes (`DASH 01`, modulo 11). */
const rotaPainel = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/painel',
  component: PaginaPainel,
});

/** Modulo 11 — custo direto por maquina, com o criterio da decisao 3. */
const rotaCustos = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/custos',
  validateSearch: validarBuscaDePeriodo,
  component: comLeitura(PaginaCustos, { licenca: LEITURA_DA_TELA['/custos'], modulo: 'os custos', sobretitulo: 'Custos', titulo: 'Custo por máquina' }),
});

/**
 * Modulo 14 — as medicoes do contrato e a receita que sai do aceite. Ela mora
 * ao lado de Custos na navegacao: margem e custo contra receita, e a pergunta
 * que as duas telas respondem e a mesma.
 */
const rotaReceita = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/receita',
  component: comLeitura(PaginaReceita, { licenca: LEITURA_DA_TELA['/receita'], modulo: 'a receita dos contratos', sobretitulo: 'Contratos e receita', titulo: 'Medições do contrato' }),
});

/**
 * Modulo 09 — a necessidade liquida de compra e os pedidos. Mora ao lado de
 * Estoque: a demanda nasce do saldo e do minimo, e o recebimento volta para o
 * livro do estoque. E a mesma pergunta, nas duas pontas.
 */
const rotaCompras = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/compras',
  /* O aviso de pedido atrasado (0091) leva ao pedido: `/compras?pedido=<id>`. */
  validateSearch: validarBuscaDeCompras,
  component: comLeitura(PaginaCompras, { licenca: LEITURA_DA_TELA['/compras'], modulo: 'as compras', sobretitulo: 'Compras e reposição', titulo: 'O que falta comprar' }),
});

/**
 * Modulo 10 — a fila de achados da inspecao, e quem ainda nao foi verificado.
 * Mora ao lado da fila de O.S.: a ferramenta 4 do v6 e, literalmente,
 * "relaciona ocorrencia, OS e liberacao".
 */
const rotaInspecao = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/inspecao',
  component: comLeitura(PaginaInspecao, { licenca: LEITURA_DA_TELA['/inspecao'], modulo: 'a inspeção', sobretitulo: 'Checklists e ocorrências', titulo: 'O que a inspeção achou' }),
});

/**
 * Modulo 16 — o que impede a operacao hoje, por documento ausente, vencido ou
 * sem validade. Ela DESLIGA o item "Operadores" do mapa: ele estava cinza
 * desde o comeco, com o icone `user` que o manual (p.14) ja reservou para
 * pessoa, e agora tem tela.
 */
const rotaPessoas = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/pessoas',
  component: PaginaPessoas,
});

/** Modulo 10 — a montagem do checklist. Pagina inteira porque a lista de
 * itens cresce, e o manual (R01, p.28) manda pagina para cadastro completo. */
const rotaChecklists = createRoute({
  getParentRoute: () => rotaRaiz,
  path: '/inspecao/checklists',
  component: comLeitura(PaginaChecklists, { licenca: LEITURA_DA_TELA['/inspecao/checklists'], modulo: 'a inspeção', sobretitulo: 'Checklists e ocorrências', titulo: 'Montar os checklists' }),
});

const arvore = rotaRaiz.addChildren([
  rotaLogin,
  rotaLoginAntigo,
  rotaPrevia,
  rotaInicio,
  rotaEquipamentos,
  rotaNovoEquipamento,
  rotaImportarEquipamentos,
  rotaCatalogo,
  rotaCombustivel,
  rotaLancamento,
  rotaLancamentoCompleto,
  rotaTanques,
  rotaOrdens,
  rotaInspecao,
  rotaChecklists,
  rotaPessoas,
  rotaConsumo,
  rotaConciliacao,
  rotaFolhas,
  rotaFolhaImpressa,
  rotaAdesivos,
  rotaIdentificacao,
  rotaCadastrosDoCombustivel,
  rotaBiblioteca,
  rotaCadastros,
  rotaGovernanca,
  rotaTrilha,
  rotaPerfil,
  rotaOperacao,
  rotaManutencao,
  rotaOrdensDeServico,
  rotaEstoque,
  rotaCompras,
  rotaPainel,
  rotaPrimeiroAcesso,
  rotaPlataforma,
  rotaPrimeiroAcessoPlataforma,
  rotaCustos,
  rotaReceita,
  rotaCausas,
  rotaFolhasDeTurno,
  rotaFolhaDeTurnoImpressa,
  rotaGestor,
  rotaPiloto,
  rotaTelemetria,
  rotaFilaDaTelemetria,
  rotaConciliacaoDaTelemetria,
  rotaIntegracoesDaTelemetria,
  rotaHistoricoDeFalhas,
  rotaRecorrencias,
  rotaPrevisoesEmPiloto,
  rotaPropostasTecnicas,
  rotaMatrizDeIntegracao,
  rotaLotesDeIntegracao,
  rotaLoteDeIntegracao,
  rotaCorrespondencias,
  rotaTitulosDaIntegracao,
  rotaDivergenciasDaTroca,
  rotaFinanceiro,
  rotaOrcamento,
  rotaRenovacao,
  rotaEstudoDeRenovacao,
  rotaInvestimentos,
  rotaQualidadeDaIa,
  rotaConciliacaoDeHoras,
  rotaImportacoes,
]);

export const roteador = createRouter({
  routeTree: arvore,
  defaultPreload: 'intent',
  /* Endereco errado e tela que quebra caem aqui, dentro da casca e em
     portugues, com o que fazer (p.23) — e nao no "Not Found" e no "Something
     went wrong!" do TanStack. */
  defaultNotFoundComponent: EnderecoInexistente,
  defaultErrorComponent: TelaQueFalhou,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof roteador;
  }
}
